import moment from 'moment-timezone';

export default (caseDelays, getAll = false) => {
  const now = moment();

  const findActiveDelay = ({ startTime, endTime }) =>
    now.isAfter(startTime) && (!endTime || now.isBefore(endTime));

  return getAll
    ? caseDelays.filter(findActiveDelay)
    : caseDelays.find(findActiveDelay);
};



// WEBPACK FOOTER //
// ./src/utils/getActiveCaseDelay.js